import { forwardRef } from 'react';
import { Avatar as AntdAvatar } from 'antd';
import clsx from 'clsx';
import styles from './Avatar.module.css';

/** @param {Object} props - Same shape as antd's own `Avatar`, forwarded as-is. */
const Avatar = forwardRef(({ className, ...props }, ref) => (
    <AntdAvatar ref={ref} className={clsx(styles.vecAvatar, className)} {...props} />
));
Avatar.displayName = 'Avatar';

export default Avatar;
